import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { getTenantId } from 'src/app/services/store-snapshot.service';
import { environment } from 'src/environments/environment';
import { FormDataService } from '../../attachments/service/form-data.service';
import { IComment, ICommentRequest } from '../model/comment.model';

@Injectable({
  providedIn: 'root',
})
export class CommentsApiService {
  private get url(): string {
    return `${environment.apiUrl}/api/${getTenantId()}`;
  }

  constructor(private http: HttpClient) {}

  getComments(entityType: number, entityId: string): Observable<IComment[]> {
    const url = `${this.url}/${entityType}/comments/${entityId}`;
    return this.http.get<IComment[]>(url);
  }

  addComment(entityType: number, comment: ICommentRequest): Observable<{ id: string }> {
    const formData = FormDataService.mapToFormData(comment);
    return this.http.post<{ id: string }>(`${this.url}/${entityType}/comments`, formData);
  }

  updateComment(entityType: number, id: string, comment: ICommentRequest): Observable<void> {
    const formData = FormDataService.mapToFormData(comment);
    return this.http.put<void>(`${this.url}/${entityType}/comments/${id}`, formData);
  }

  deleteComment(entityType: number, entityId: string, id: string): Observable<void> {
    return this.http.delete<void>(`${this.url}/${entityType}/comments/${entityId}/${id}`);
  }
}
